import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useContext, useEffect, useState } from "react";
import { FormContainer, useForm } from "react-hook-form-mui";
import { APIContext } from "../../../../Contexts/APIContext";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import TravelPlanV2ViewModel from "../../../ViewModels/TravelPlan/TravelPlanV2ViewModel";
import TravelPlanCarParkingV2 from "./TravelPlanCarParkingV2";
import TravelPlanCarSharingV2 from "./TravelPlanCarSharingV2";
import TravelPlanCyclingV2 from "./TravelPlanCyclingV2";
import TravelPlanIncentives from "./TravelPlanIncentives";
import TravelPlanMainDetailsV2 from "./TravelPlanMainDetailsV2";
import TravelPlanMarketingSuite from "./TravelPlanMarketingSuite";
import TravelPlanPublicTransportV2 from "./TravelPlanPublicTransportV2";
import TravelPlanSiteChangesV2 from "./TravelPlanSiteChangesV2";
import TravelPlanTargetsAndObjectives from "./TravelPlanTargetsAndObjectives";
import TPShuttleBus from '../ShuttleBus';
import isResidentialTravelPlan from "../isResidentialTravelPlan";
import SiteViewModel from '../../../ViewModels/SiteViewModel';
import EditControl from "../../EditControl";

interface IProps {
    typeDropdown: DropDownViewModel[] | []
    groupDropdown: DropDownViewModel[] | []
    id: string
    site: SiteViewModel
    startInEdit?: boolean
}

export default function TravelPlanTabsV2({ typeDropdown, groupDropdown, id, site, startInEdit = false }: IProps) {

    const [tabVal, setTabVal] = useState(0);
    const [readOnly, setReadOnly] = useState(!startInEdit);

    const landUse = id.split('-')[1];
    const subUse = id.split('-')[2];
    const isResidential = isResidentialTravelPlan(landUse, subUse);

    const formContext = useForm<TravelPlanV2ViewModel>({
        defaultValues: new TravelPlanV2ViewModel(),
    });

    const { reset } = formContext;
    const { get, post, showMessage } = useContext(APIContext);

    useEffect(() => {
        getTravelPlan();
        reset(new TravelPlanV2ViewModel)
    }, []);

    useEffect(() => {
        if (id) {
            getTravelPlan(!readOnly);
        }
    }, [readOnly]);

    const getTravelPlan = (isEdit?: boolean) => {
        get('TravelPlan', `GetTravelPlan?id=${id}&isEdit=${isEdit}`, reset)
    };

    const tabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabVal(newValue);
    };

    const submit = (form: any) => {

        post('TravelPlan', `UpdateTravelPlanV2?reference=${id}`, form, async () => {
            await getTravelPlan(false)
            showMessage('success', 'Travel Plan updated successfully')
            setReadOnly(true);
        });
    }

    return (
        <>
            <Tabs value={tabVal} onChange={tabChange} >
                <Tab label="Main Details" value={0} />
                <Tab label="Objectives & Targets" value={1} />
                <Tab label="Site Changes" value={2} />
                <Tab label="Cycling" value={3} />
                <Tab label="Car Sharing" value={4} />
                <Tab label="Car Parking" value={5} />
                <Tab label="Incentives" value={6} />
                <Tab label="Public Transport" value={7} />
                <Tab label={landUse == '03' ? "Marketing Suite" : "Shuttle Bus"} value={8} />
            </Tabs>

            <FormContainer formContext={formContext} onSuccess={submit}>
                <EditControl readOnly={readOnly} setReadOnly={setReadOnly} />
                {tabVal == 0 && <TravelPlanMainDetailsV2 planTypes={typeDropdown} isReadOnly={readOnly} />}
                {tabVal == 1 && <TravelPlanTargetsAndObjectives targetGroups={groupDropdown} isReadOnly={readOnly} id={id} site={site} />}
                {tabVal == 2 && <TravelPlanSiteChangesV2 isReadOnly={readOnly} />}
                {tabVal == 3 && <TravelPlanCyclingV2 isReadOnly={readOnly} isResidential={isResidential} />}
                {tabVal == 4 && <TravelPlanCarSharingV2 isReadOnly={readOnly} isResidential={isResidential} />}
                {tabVal == 5 && <TravelPlanCarParkingV2 isReadOnly={readOnly} isResidential={isResidential} />}
                {tabVal == 6 && <TravelPlanIncentives isReadOnly={readOnly} isResidential={isResidential} />}
                {tabVal == 7 && <TravelPlanPublicTransportV2 isReadOnly={readOnly} isResidential={isResidential} />}
                {tabVal == 8 && (landUse === '03' ? <TravelPlanMarketingSuite isReadOnly={readOnly} /> : <TPShuttleBus isReadOnly={readOnly} />)}
            </FormContainer>
        </>
    );
}
